<template>
  <div
    id="detailsform"
    class="
      shadow-xl
      rounded-md
      ml-16
      mx-5
      my-5
      border-2 border-blue-600
      lg:relative
    "
  >
    <div
      class="
        flex flex-row
        items-center
        space-x-4
        m-5
        justify-start
        flex-wrap
        relative
      "
    >
      <div id="profile">
        <div class="avatar">
          <div class="mb-8 w-24 h-24 mask">
            <img src="@/assets/log-in.png" alt="user-profile image" />
          </div>
        </div>
      </div>
      <div id="profiledata" class="flex-1">
        <div class="form-control w-full">
          <label class="label">
            <span class="label-text">User Name</span>
          </label>
          <input
            type="text"
            disabled="disabled"
            placeholder="Username"
            v-model="name"
            class="input input-bordered"
          />
        </div>
        <div class="form-control w-full">
          <label class="label">
            <span class="label-text">Mobile No</span>
          </label>
          <input
            type="text"
            v-model="mobno"
            disabled="disabled"
            placeholder="Mobile no"
            class="input input-bordered"
          />
        </div>
        <div class="form-control w-full">
          <label class="label">
            <span class="label-text">Date of Birth</span>
          </label>
          <input
            type="text"
            v-model="dob"
            disabled="disabled"
            placeholder="DOB"
            class="input input-bordered"
          />
        </div>
      </div>
      <div class="absolute -top-7 -right-7">
        <div class="btn btn-info">
          Id :
          <div class="badge ml-2 badge-lg badge-ghost relative">
            <span
              class="
                animate-ping
                absolute
                -top-5
                -right-5
                inline-flex
                h-5
                w-5
                rounded-full
                bg-yellow-400
                opacity-80
              "
            ></span>
            {{ this.$store.state.Candidate.application.Id }}
          </div>
        </div>
      </div>
    </div>
    <alertmodal :newUser="newUser" :closeModal="closeModal">
      <template v-slot:msg>
        Welcome to SITRA Employement Service, Thank you for choosing us. To get
        started fill the application form.
      </template>
    </alertmodal>
  </div>
</template>

<script>
import axios from "axios";
import alertmodal from "../../alertmodal.vue";
export default {
  components: { alertmodal },
  name: "Profilecard",
  data() {
    return {
      newUser: false,
      name: null,
      mobno: null,
      dob: null,
    };
  },
  mounted() {
    this.getUserinfo();
  },
  methods: {
    closeModal() {
      this.newUser = false;
    },
    getUserinfo() {
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/CandidatesDetails`,
          {
            Reg_id: sessionStorage.getItem("id"),
          }
        )
        .then((res) => {
          // console.log(res);
          if (res.data.length == 0) {
            this.newUser = true;
            this.name = "";
            this.mobno = "";
            this.dob = "";
          } else {
            this.name = res.data[0].Candidate_name;
            this.mobno = res.data[0].Candidate_mobileno;
            this.dob = res.data[0].DOB;
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style></style>
